module.exports = __webpack_public_path__ + "5875-shadow.113f2460279322f2d02260b744b27fb9.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/5875-shadow.png
// module id = 632
// module chunks = 0